import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {AuthService} from "./auth.service";

@NgModule({})
export class AuthModule {
    constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
        if (parentModule) {
            throw new Error('AuthModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the AuthService.
     * @return ModuleWithProviders
     */
    static forRoot(config?: AuthConfig): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                {provide: AuthService.HTTP_TIMEOUT_KEY, useValue: config ? config.httpTimeout : 0}
            ]
        };
    }
}

export class AuthConfig {
    httpTimeout: number;
}
